import React from 'react'
import { CSVIconSVG, DocumentIconSVG, ExcelIconSVG, ImageIconSVG, PDFIconSVG } from '../../assets/icon/svg';

export const GetIconFile = (fileName: string) => {
    const extension = fileName.split(".").pop()?.toLowerCase();
    
        switch (extension) {
            case "pdf":
                return <PDFIconSVG size={20} />;

            case "csv":
                return <CSVIconSVG size={20} />;

            case "xls":
            case "xlsx":
                return <ExcelIconSVG size={20} />;

            case "png":
            case "jpg":
            case "jpeg":
            case "gif":
            case "bmp":
            case "webp":
            case "svg":
                return <ImageIconSVG size={20} />;

            default:
                return <DocumentIconSVG size={20} />;
        }
}
